import PropTypes from "prop-types";

export const PageTitle = ({ title, className = "" }) => {
  return <div className={`app-page-title ${className}`}>{title}</div>;
};

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
};
